import { z } from 'zod';

export const querySchema = z.object({
  details: z.string().default(''),
});
